import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
  versionDropdown: {
    minWidth: '180px',
  },
});
